// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".liste_dispo_remplacant[data-v-7c9a4f5c]{max-height:calc(100vh - 230px);min-height:calc(100vh - 230px);overflow-y:auto;overflow-x:hidden}.message_astreinte_detail[data-v-7c9a4f5c]{min-height:24px}", ""]);
// Exports
module.exports = exports;
